/** basic.pushRecords */
export default {
    public_time: "Время вызова",
    public_pushMeassger: "Содержимое push",
    public_deviceNum: "Единый код устройства",

    AliSmsPhone: "Номер телефона",
    AliSmsTime: "Время события",
    AliSmsEventType: "Тип события",
    AliSmsEvent_alarm: "Событие тревоги",
    AliSmsEvent_fault: "Событие неисправности",
    AliSmsEvent_heartbeat: "Событие heartbeat",
    AliSmsEvent_deviceOffLine: "Событие: устройство офлайн",
    AliSmsEvent_deviceOnLine: "Событие: устройство онлайн",
    AliSms_newMessage: "Текст сообщения",

    // 语音推送
    AliVoiceTime: "Время вызова",
    AliVoicePush: "Содержимое push",

    // 公众号
    publicAccount_template: "ID шаблона",
    publicAccount_pushUser: "ID пользователя push",
    publicAccount_errmsg: "Описание результата",
    publicAccount_msgid: "ID сообщения",
    publicAccount_deviceNum: "Единый код устройства",
    publicAccount_ruleId: "ID правила",

    // 专线
    specialLine_answerState: "Статус ответа",
    specialLine_userNoAnswer: "Пользователь не ответил",
    specialLine_refuseAnswer: "Пользователь отказался отвечать",
    specialLine_answerButFinish: "Пользователь ответил и завершил звонок",
    specialLine_answerButPassivityFinish: "Пользователь ответил, звонок завершён принудительно",
    specialLine_answerTIme: "Время ответа",
    specialLine_noAnswer: "Без ответа",
    specialLine_overTime: "Время завершения",

    // app推送
    appPush_pushResult: "Результат push",
    appPush_pushRState: "Статус push",

    // 阿里云电话记录
    aliPho_phoneSearPla: "Поиск по телефону",
    aliPho_rulesPhone: "Введите 11-значный номер телефона",

    user_mame: "Имя пользователя",
    push_Result: "Результат push",
    Push_Descriptive: "Описание push",
    Event_Name: "Название события",
    push_time: "Время push",

    push_success: "Push успешно отправлен",
    push_limit: "Достигнут лимит отправок по этому шаблону",
    push_content_not_issue: "Этот контент не поддерживается для отправки",
    push_content_abnormal: "Некорректный контент отправки",
    push_account_maximum_issue: "Достигнут лимит отправок аккаунта, вызовы ограничены",
    push_template_under_review: "Контент шаблона находится на проверке",
    push_Poorly_formatted_fields: "Неверный формат поля",
    push_Public_Exception: "Ошибка push официального аккаунта",
}

